import { _js } from '@ifixit/localize';
import { faBell } from '@fortawesome/pro-solid-svg-icons/faBell';
import Dropdown from './dropdown';
import NotificationsDisplay from './notifications_display';
import Notifications from 'Shared/Notifications/notifications';

function NotificationsDropdown({
   notifications,
   notificationsUrl,
}: {
   notifications: Notifications;
   notificationsUrl: string;
}) {
   const unreadNotifications = notifications.getUnreadNotifications();
   const hasUnread = unreadNotifications.length != 0;

   const label = hasUnread ? 'unread notifications dropdown' : 'notifications dropdown';

   return (
      <Dropdown label={label} iconName={faBell} hasBadge={hasUnread}>
         {hasUnread ? (
            <NotificationsDisplay
               unreadNotifications={unreadNotifications}
               notificationsUrl={notificationsUrl}
               markAllRead={notifications.markAllRead}
            />
         ) : (
            <p style={{ display: 'flex', justifyContent: 'center', padding: '0 8px 0 8px' }}>
               {_js('No notifications!')}
            </p>
         )}
      </Dropdown>
   );
}

export default NotificationsDropdown;
